import { render, staticRenderFns } from "./AboutGPTW.vue?vue&type=template&id=460b8c58&scoped=true&"
import script from "./AboutGPTW.vue?vue&type=script&lang=js&"
export * from "./AboutGPTW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460b8c58",
  null
  
)

export default component.exports